"use strict";

function __export(m) {
  for (var p in m) {
    if (!exports.hasOwnProperty(p)) exports[p] = m[p];
  }
}

Object.defineProperty(exports, "__esModule", {
  value: true
});

__export(require("./core/transcriber"));

__export(require("./code-object/export-class"));

__export(require("./code-object/local-context"));

__export(require("./code-object/inline-context"));

__export(require("./code-object/method"));

__export(require("./code-object/module"));

__export(require("./plug-in/draft-plugin-class"));

__export(require("./plug-in/draft-plugin-dsl"));

__export(require("./plug-in/draft-plugin-filter"));

__export(require("./plug-in/draft-plugin-local-context"));

__export(require("./plug-in/draft-plugin-refresh"));

__export(require("./common/utility"));
/**
 *
 */


var transcriber_1 = require("./core/transcriber");

var draft_plugin_refresh_1 = require("./plug-in/draft-plugin-refresh");

var draft_plugin_dsl_1 = require("./plug-in/draft-plugin-dsl");

var draft_plugin_local_context_1 = require("./plug-in/draft-plugin-local-context");

var draft_plugin_class_1 = require("./plug-in/draft-plugin-class");

var draft_plugin_filter_1 = require("./plug-in/draft-plugin-filter");

var draft_plugin_inplace_context_1 = require("./plug-in/draft-plugin-inplace-context");

function MakeDefaultTranscriber(_module) {
  var transcriber = new transcriber_1.Transcriber(_module);
  transcriber.m_Plugins = [new draft_plugin_inplace_context_1.InplaceContextPlugin(transcriber), new draft_plugin_refresh_1.RefreshDraftPlugin(transcriber), new draft_plugin_dsl_1.DSLPlugin(transcriber), new draft_plugin_refresh_1.RefreshDraftPlugin(transcriber), new draft_plugin_local_context_1.LocalContextPlugin(transcriber), new draft_plugin_class_1.ClassPlugin(transcriber), new draft_plugin_filter_1.FilterPlugin(transcriber)];
  return transcriber;
}

exports.MakeDefaultTranscriber = MakeDefaultTranscriber;